import { FaceIdProfileCreation } from '@/features/face-id-profiles';

const FaceIdProfileCreationPage = () => {
  return <FaceIdProfileCreation />;
};

export default FaceIdProfileCreationPage;
